/**
 * Pending API Endpoints
 * Centralized endpoint definitions for pending operations.
 */
export const PENDING_ENDPOINTS = {
  /**
   * Get filtered list of pending samples
   * @method GET
   * @endpoint /pending/samples
   * @query PendingFilters
   */
  SAMPLES: "/pending/samples",

  /**
   * Get pending results for a sample
   * @method GET
   * @endpoint /pending/samples/{barcode}
   * @param {string} barcode - Sample barcode
   */
  SAMPLE_BY_BARCODE: (barcode: string) => `/pending/samples/${encodeURIComponent(barcode)}`,

  /**
   * Update sample barcode
   * @method PATCH
   * @endpoint /pending/samples/{sampleId}
   * @param {string} sampleId - Original sample barcode
   */
  UPDATE_SAMPLE_BARCODE: (sampleId: string) => `/pending/samples/${encodeURIComponent(sampleId)}`,

  /**
   * Delete all results for a sample
   * @method DELETE
   * @endpoint /pending/samples/{sampleId}
   * @param {string} sampleId - Sample barcode
   */
  DELETE_SAMPLE: (sampleId: string) => `/pending/samples/${encodeURIComponent(sampleId)}`,

  /**
   * Upload all results for a sample to LIS
   * @method POST
   * @endpoint /pending/samples/{sampleId}
   * @param {string} sampleId - Sample barcode
   */
  PUBLISH_SAMPLE: (sampleId: string) => `/pending/samples/${encodeURIComponent(sampleId)}`,

  /**
   * Get a specific result by ID
   * @method GET
   * @endpoint /pending/results/{resultId}
   * @param {number} resultId - Result ID
   */
  RESULT_BY_ID: (resultId: number) => `/pending/results/${resultId}`,

  /**
   * Delete a specific result
   * @method DELETE
   * @endpoint /pending/results/{resultId}
   * @param {number} resultId - Result ID
   */
  DELETE_RESULT: (resultId: number) => `/pending/results/${resultId}`,

  /**
   * Upload a specific result to LIS
   * @method POST
   * @endpoint /pending/results/{resultId}
   * @param {number} resultId - Result ID
   */
  PUBLISH_RESULT: (resultId: number) => `/pending/results/${resultId}`,

  /**
   * Update a specific result value
   * @method PATCH
   * @endpoint /pending/results/{resultId}
   * @param {number} resultId - Result ID
   */
  UPDATE_RESULT: (resultId: number) => `/pending/results/${resultId}`,

  /**
   * Get enum values for a specific test code
   * @method GET
   * @endpoint /pending/enum-values/{testCode}
   * @param {string} testCode - Test code
   */
  ENUM_VALUES: (testCode: string) => `/pending/enum-values/${encodeURIComponent(testCode)}`,

  /**
   * Get filtered list of pending visits
   * @method GET
   * @endpoint /pending/visits
   * @query PendingFilters (without filterUnknown)
   */
  VISITS: "/pending/visits",

  /**
   * Get pending results for a visit
   * @method GET
   * @endpoint /pending/visits/{visitId}
   * @param {string} visitId - Visit ID
   */
  VISIT_BY_ID: (visitId: string) => `/pending/visits/${encodeURIComponent(visitId)}`,
} as const;
